import React from 'react';
import CategorySpecsRender from '../../components/CategorySpecsRender';
import { translate } from 'react-i18next';
import { compose } from 'redux';
import { connect } from 'react-redux'
import { firebaseConnect } from 'react-redux-firebase'
import { yearChange } from '../../actions'

class CategorySpecs extends React.Component {

  state = {
    category: '',
    categories: null
  }

  changeCategory = (category) => {
    this.setState({category: category})
  }

  componentWillReceiveProps() {
    let category;
    if (this.props.category) {
      category = Object.entries(this.props.category)
      this.setState({categories: category, category: category[0] && category[0][1].name})
    }
  }

  render() {

    //Get amount per cluster
    let clusterList;
    let cluster = [];
    if (this.props.category && this.props.logs && this.props.cluster && this.state.categories) {
        clusterList = Object.entries(this.props.cluster)
        // Find the ID of selected category
        let categoryId = this.state.categories.filter( category =>
          category[1].name == this.state.category
        )
        categoryId = categoryId[0][0]
        clusterList = clusterList.filter( cluster =>
        //For production DB:
        cluster[1].category == categoryId
        //For staging DB:
      //    cluster[1].category == this.state.category
          &&
          cluster[1].readOnly == false
        )
        cluster = []
        clusterList.map( item =>
          cluster.push({'name': item[1].name, value: 0})
        )
    }

      //Assign values (amount/cluster)
      if (this.props.logs && cluster && clusterList && this.state.category != '') {
        let allLogs = Object.entries(this.props.logs)
        clusterList.map( (item, index) => {
          let count = allLogs.filter( log =>
            log[1].atl_cluster.name == item[1].name && log[1].atl_category.name == this.state.category
          )
          count = count.length
          cluster[index].value = count
          }
        )
      }

    const { t } = this.props;
    return (
      <CategorySpecsRender
        distribution={cluster}
        amount={cluster}
        categories={this.state.categories}
        changeCategory={(category) => this.changeCategory(category)}
        t={this.props.t}
        currentYear={this.props.currentYear}
        changeYear={this.props.changeYear}
        allYears={this.props.allYears}
        gradeSelected={this.props.gradeSelected}
       />
    )
  }
}

const enhancer = compose(
  translate('lang'),
  firebaseConnect((props) => {
    return [
      'atl_category', 'atl_cluster'
    ]
  }),
  connect(
    state => ({
      category: state.firebase.data.atl_category || {},
      logs: state.relevantLogs.logs,
      cluster: state.firebase.data.atl_cluster,
      currentYear: state.currentYear,
      allYears: state.allYears && state.allYears.years,
      gradeSelected: state.selectedClass.id == 'All' ? false : true
    }),
    {changeYear: yearChange}
  )
)
export default enhancer(CategorySpecs);



// WEBPACK FOOTER //
// ./src/containers/CategorySpecs/index.jsx